/**
 * Public camps API — the names the app and tests import. Built once, for
 * camps and clinics alike, in publicTypedEventsAPI.ts.
 */
import { createPublicTypedEventsAPI } from "./publicTypedEventsAPI";

export type {
  PublicTypedEvent as PublicCamp,
  GuestRegistrationData,
  BatchParticipant,
  BatchGuestRegistrationData,
  MemberLookupAthlete,
  MemberLookupResult,
  MemberVerifyResult,
} from "./publicTypedEventsAPI";

const api = createPublicTypedEventsAPI("camp");

export const lookupMemberByEmail = api.lookupMemberByEmail;
export const verifyMemberByEmail = api.verifyMemberByEmail;
export const getPublicCamps = api.getPublicTypedEvents;
export const getPublicCampById = api.getPublicTypedEventById;
export const registerGuestForCamp = api.registerGuestForTypedEvent;
export const confirmCampPayment = api.confirmTypedEventPayment;
export const batchRegisterGuestForCamp = api.batchRegisterGuestForTypedEvent;
